import { Result } from "neverthrow";

type AggregateCompany = {
    id: number;
    descripcion: string;
}

type AggregateProcess = {
    id: number;
    descripcion: string;
}

export enum CompanyProcessStatus{
    STOPPED = 0,
    PLAYING = 1
}

export type CompanyProcess = {
    id: number;
    nombre: string;
    publicId: string;
    horaInicio: string;
    horaFin: string;
    lunes: boolean;
    martes: boolean;
    miercoles: boolean;
    jueves: boolean;
    viernes: boolean;
    sabado: boolean;
    domingo: boolean;
    fechaCreacion: string | null;
    fechaActualizacion: string | null;
    proceso: AggregateProcess;
    detenido: 1 | 0;
    activo: 1 | 0;
    empresa: AggregateCompany;
}

export type CreateCompanyProcessPayload = {
    empresaId: number;
    nombre: string;
    horaInicio: string;
    horaFin: string;
    lunes: boolean;
    martes: boolean;
    miercoles: boolean;
    jueves: boolean;
    viernes: boolean;
    sabado: boolean;
    domingo: boolean;
    detenido: number,
    activo: number,
}

export type UpdateCompanyProcessPayload =  CreateCompanyProcessPayload & {
    id: number;
}

export type UpdateCompanyProcessStatusPayload = {
    id: string,
    activo: 'play' | 'stop'
    detenido: 'play' | 'stop'
}

export type CreateCompanyProcessResult = Promise<Result<boolean, Error>>
export type UpdateCompanyProcessResult = Promise<Result<boolean, Error>>
export type DeleteCompanyProcessResult = Promise<Result<boolean, Error>>
export type UpdateCompanyProcessStatusResult = Promise<Result<boolean, Error>>

export type CompanyProcessValues = {
    empresaId: number,
    nombre: string,
    horaInicio: string,
    horaFin: string,
    lunes: boolean,
    martes: boolean,
    miercoles: boolean,
    jueves: boolean,
    viernes: boolean,
    sabado: boolean,
    domingo: boolean,
    detenido: number,
    activo: number,
}
